export default "__VITE_ASSET__CqdXvpDs__"